const Storage = require('utils/storage');
const PersistenceConfig = require('./persistence-config');

const STORAGE_KEY = PersistenceConfig.keys.continuation;
const internals = {};

module.exports = { STORAGE_KEY, save, peek, consume, clear, captureFromLocation, captureDestination,
    deferForCommunity, getCommunityTarget, isDeferred };

function save({ redirect, target, pendingSchoolId, pendingProfileSchoolId } = {}) {

    if (!['after-auth', 'welcome', 'join-school-profile'].includes(redirect)) {
        return;
    }

    const continuation = { redirect };

    if (internals.isLocalAppTarget(target)) {
        continuation.target = target;
        const schoolId = Number(pendingSchoolId);
        if (Number.isSafeInteger(schoolId) && schoolId > 0) {
            continuation.pendingSchoolId = schoolId;
        }

        const profileSchoolId = Number(pendingProfileSchoolId || (!continuation.pendingSchoolId
            && redirect === 'join-school-profile' && new URL(target, 'https://nearpeer.net').searchParams.get('s')));
        if (Number.isSafeInteger(profileSchoolId) && profileSchoolId > 0) {
            continuation.pendingProfileSchoolId = profileSchoolId;
        }
    }

    Storage.session?.set?.(STORAGE_KEY, continuation);
}

function deferForCommunity({ schoolId, target } = {}) {

    if (Number.isSafeInteger(Number(schoolId)) && Number(schoolId) > 0 && internals.isLocalAppTarget(target)) {
        save({ redirect: 'after-auth', target, pendingSchoolId: Number(schoolId) });
    }
}

function isDeferred(continuation = peek()) {

    return !!continuation.pendingSchoolId || !!continuation.pendingProfileSchoolId
        || (continuation.redirect === 'join-school-profile' && internals.isLocalAppTarget(continuation.target));
}

function getCommunityTarget(schoolId) {

    const continuation = peek();
    if (!internals.isLocalAppTarget(continuation.target)) {
        return;
    }

    const url = new URL(continuation.target, 'https://nearpeer.net');
    if (url.pathname === '/app/manage-communities'
        || (url.pathname === '/app/profile/edit' && url.searchParams.get('confirm') === 'true')) {
        return;
    }

    const targetSchoolId = Number(url.searchParams.get('s') || continuation.pendingSchoolId || continuation.pendingProfileSchoolId);
    if (Number.isSafeInteger(targetSchoolId) && targetSchoolId > 0 && targetSchoolId === Number(schoolId)) {
        return continuation.target;
    }
}

function peek() {

    return Storage.session?.get?.(STORAGE_KEY) || {};
}

function clear() {

    Storage.session?.remove?.(STORAGE_KEY);
}

function consume() {

    const continuation = peek();
    clear();
    return continuation;
}

function captureFromLocation(location = typeof window === 'undefined' ? {} : window.location) {

    const query = new URLSearchParams(location?.search || '');

    if (!query.has('redirect') && !query.has('target')) {
        return;
    }

    save({ redirect: query.get('redirect'), target: query.get('target') });
    query.delete('redirect');
    query.delete('target');

    if (typeof window !== 'undefined' && location.search === window.location.search) {
        const search = query.toString();
        const path = `${location.pathname || window.location.pathname}${search ? `?${search}` : ''}${location.hash || window.location.hash || ''}`;
        window.history.replaceState(window.history.state, document.title, path);
    }

    return true;
}

function captureDestination(location = typeof window === 'undefined' ? {} : window.location) {

    const target = `${location.pathname || ''}${location.search || ''}`;

    if (isDeferred() && (location.pathname === '/app/manage-communities'
        || (location.pathname === '/app/profile/edit' && new URLSearchParams(location.search || '').get('confirm') === 'true'))) {
        return;
    }

    if (location.pathname !== '/app/verify-phone' && internals.isLocalAppTarget(target)) {
        save({ redirect: 'after-auth', target });
    }
    else if (location.pathname?.startsWith('/signup') && new URLSearchParams(location.search || '').has('v')) {
        clear();
    }
}

internals.isLocalAppTarget = (target) => {

    if (typeof target !== 'string' || !target.startsWith('/app/') || /[\\#\u0000-\u0020]/.test(target)) {
        return false;
    }

    try {
        const url = new URL(target, 'https://nearpeer.net');
        return url.pathname.startsWith('/app/') && url.pathname !== '/app/loader';
    }
    catch (err) {
        return false;
    }
};
